import Tabs from '@gp/components/NewIconTabs';
import React from 'react';
import { Layout } from 'tea-component';
import { connect } from 'umi';
import './index.scss';
const { Content } = Layout;

function HeaderDetails(props: any) {
  //  activeId 选中的tab
  //  tabList tab数据
  //  change tab选中事件
  //  title  标题
  //   children 前边自定义内容
  //   operation 右边自定义内容
  const {
    activeId,
    tabList,
    change,
    title,
    children,
    className,
    operation,
    goBackHandle,
    newMarkCfgMapping,
  } = props;

  return (
    <Content.Header
      showBackButton
      onBackButtonClick={() => {
        if (goBackHandle) {
          goBackHandle();
        } else {
          window.history.back();
        }
      }}
      title={title}
      operation={operation}
      // contentHead-normal 是定位 tab
      className={`${className ? className : ''} details-header contentHead-normal`}
    >
      {children}
      <div className="header-tab dbg-header-tab">
        <Tabs
          ceiling
          className="dbg-user-guide__game-details-tabs"
          newMarkCfgMapping={newMarkCfgMapping}
          tabs={tabList}
          animated={false}
          activeId={activeId}
          onActive={(tab) => {
            change(tab);
          }}
        />
      </div>
    </Content.Header>
  );
}

export default connect((state: any) => {})(HeaderDetails);
